import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../molecules/NoData";
import { formatCurrency } from "../../../utils/formatCurrency";
import useModal from "../../../hooks/useModal";
import { useState } from "react";
import ModalConfirm from "../../molecules/ModalConfirm";
import { UPDATE_MANTENIMIENTO } from "../../../api/apiMantenimiento";
import { toast } from "react-toastify";
import { useSession } from "../../../context/SessionContext";

const MantenimientoTable = ({ data, loading, inmuebles, staff, refetch }) => {
    const { user } = useSession();
    const { open, isOpen, close } = useModal();
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [selected, setSelected] = useState();

    const handleUpdateMantenimiento = async () => {
        try {
            setLoadingUpdate(true);
            let values;

            if (selected?.staffId) {
                values = {status:"Realizado" };
            } else if (!selected.staffId) {
                values = {status:"Realizado", staffId: user?.id };
            }
            await UPDATE_MANTENIMIENTO(selected.id, values);
            toast.success("Actualizado exitosamente");
            refetch();
            handleClose();
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingUpdate(false);
        }
    };

    const handleSelect = (registro) => {
        setSelected(registro);
        open();
    };

    const handleClose = () => {
        close();
        setSelected(null);
    };

    const getInmuebleName = (propertieId) => {
        const inmueble = inmuebles?.find((item) => item.id === propertieId);
        return inmueble ? inmueble.name : "Inmueble desconocido";
    };

    const getName = (staffId) => {
        const staffName = staff?.find((person) => person.id === staffId);
        return staffName ? staffName.name : "Desconocido";
    };

    const columns = [
        {
            name: "Inmueble",
            selector: (row) => getInmuebleName(row.propertieId),
        },
        {
            name: "Costo",
            selector: (row) => formatCurrency(row.cost),
        },
        {
            name: "Servicio",
            selector: (row) => row.description,
        },
        {
            name: "Estatus",
            selector: (row) => <button onClick={row.status === "Pendiente" ? ()=> handleSelect(row) : null} className={`${row.status === "Pendiente" ? "bg-red-500" : "bg-green-600"} text-white p-2 rounded-lg font-bold`}> {row.status} </button>,
        },
        {
            name: "Responsable",
            selector: (row) => (getName(row?.staffId)),
        },
        {
            name: "Fecha del servicio",
            selector: (row) => row.date_service,
        },
    ];

    const columnsMantenimiento = [
        {
            name: "Inmueble",
            selector: (row) => getInmuebleName(row.propertieId),
        },
        {
            name: "Servicio",
            selector: (row) => row.description,
        },
        {
            name: "Estatus",
            selector: (row) => <button onClick={row.status === "Pendiente" ? ()=> handleSelect(row) : null} className={`${row.status === "Pendiente" ? "bg-red-500" : "bg-green-600"} text-white p-2 rounded-lg font-bold`}> {row.status} </button>,
        },
        {
            name: "Responsable",
            selector: (row) => (getName(row?.staffId)),
        },
        {
            name: "Fecha del servicio",
            selector: (row) => row.date_service,
        },
    ];

    return (
        <>
            <DataTable
                data={data}
                progressPending={loading}
                columns={user?.role === "Staff" ? columnsMantenimiento : columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData />}
                pagination
            />
            {isOpen &&
                <ModalConfirm onClose={handleClose} onConfirm={handleUpdateMantenimiento} loading={loadingUpdate} />
            }
        </>
    );
};

export default MantenimientoTable;